import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@/components/ui-v2';

export interface ChangeRoleModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    memberName: string;
    workspaceName: string;
    fromRoleName: string | null;
    toRoleName: string;
    submitting?: boolean;
}

export default function ChangeRoleModal({
    open,
    onClose,
    onConfirm,
    memberName,
    workspaceName,
    fromRoleName,
    toRoleName,
    submitting,
}: ChangeRoleModalProps) {
    const isAdding = !fromRoleName;
    const title = isAdding ? `Add ${memberName} to ${workspaceName}?` : `Change ${memberName}'s role in ${workspaceName}?`;

    return (
        <Modal open={open} onClose={onClose} width={460}>
            <ModalHeader onClose={onClose}>{isAdding ? 'Add to workspace' : 'Change role'}</ModalHeader>
            <ModalBody>
                <p className="text-sm text-gray-800 mb-3">{title}</p>
                {isAdding ? (
                    <p className="text-sm text-gray-600">
                        New role: <span className="font-medium">{toRoleName}</span>
                    </p>
                ) : (
                    <p className="text-sm text-gray-600">
                        From <span className="font-medium">{fromRoleName}</span> → To{' '}
                        <span className="font-medium">{toRoleName}</span>
                    </p>
                )}
                <p className="text-xs text-gray-500 mt-3">
                    {memberName} will receive an email letting them know.
                </p>
            </ModalBody>
            <ModalFooter>
                <Button variant="secondary" onClick={onClose} disabled={submitting}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onConfirm} disabled={submitting}>
                    {submitting ? 'Saving…' : isAdding ? 'Add to workspace' : 'Change role'}
                </Button>
            </ModalFooter>
        </Modal>
    );
}
